export const newMessageStateEnum = Object.freeze({
    "ACTION":       1,
    "RECIPIENT":    2,
    "MESSAGE":      3
});